export default __webpack_public_path__ + "postMock.ee1692f1c4084b4d91e7faf1162114e3.html";